import { useState } from 'react';
import useFetch from '../hooks/useFetch'
import { objectToQueryString } from '../utils';
import { apiWrapper, apiDownloadWrapper } from './dataHookUtils'

export default () => {
  const [isLoading, setIsLoading] = useState(true)
  const [attendees, setAttendees] = useState([])

  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const fetchAttendees = async (filters = {}) => {
    try {
      setIsLoading(true);
      const response = await fetch(`events/event/attendees?${objectToQueryString(filters)}`, { method: 'GET' })
      const jsonData = await response.json()
      if (jsonData.error) {
        setAttendees([])
      } else {
        setAttendees(jsonData)
      }
     setIsLoading(false)
    } catch (e) {
      console.log(e)
      setAttendees([])
      setIsLoading(false)
    }
  }

  const addNewAttendee = async (attendeeData) => {
    return apiWrapper({
      fetch,
      url: `events/event/attendee/new`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: attendeeData })
      }
    });
  }

  const updateAttendee = async (attendeeData) => {
    return apiWrapper({
      fetch,
      url: `events/event/attendee/update`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: attendeeData })
      }
    });
  }

  const deleteAttendee = async (attendeeData) => {
    return apiWrapper({
      fetch,
      url: `events/event/attendee/delete`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: attendeeData })
      }
    });
  }

  const downloadAttendees = async (filters = {}) => {
    return apiDownloadWrapper({
      fetch,
      url: `events/event/attendees/download?${objectToQueryString(filters)}`,
      options: {
        method: 'GET'
      }
    });
  }

  return {
    isLoading,
    attendees,
    fetchAttendees,
    addNewAttendee,
    updateAttendee,
    deleteAttendee,
    downloadAttendees
  }
}